import { useQuery, keepPreviousData } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";

/**
 * Per-organization cost for one external provider, with a purpose breakdown
 * under each org and a separate "Platform overhead" bucket for calls that
 * belong to no single customer (crons, admin syncs, migrations).
 *
 * Cache hits never reach the provider, so they are never counted here.
 *
 * params: { provider, timeFrame } or { provider, from, to }
 */
export const useGetExternalApiCostSummaryQuery = (params = {}, enabled = true) => {
  const { data, isPending, isFetching, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_EXTERNAL_API_COST_SUMMARY, params],
    queryFn: () =>
      api.get(API_ROUTES.GET_EXTERNAL_API_COST_SUMMARY, { params }),
    placeholderData: keepPreviousData,
    enabled,
  });
  return {
    data: data?.data?.data ?? null,
    isPending,
    isFetching,
    isError,
    error,
  };
};

/**
 * Calls grouped by endpoint / purpose / package / source / day — the
 * engineering view of which code is making the calls.
 *
 * params: { provider, groupBy, timeFrame }
 */
export const useGetExternalApiStatsQuery = (params = {}, enabled = true) => {
  const { data, isPending, isFetching, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_EXTERNAL_API_STATS, params],
    queryFn: () => api.get(API_ROUTES.GET_EXTERNAL_API_STATS, { params }),
    placeholderData: keepPreviousData,
    enabled,
  });
  return {
    data: data?.data?.data ?? null,
    isPending,
    isFetching,
    isError,
    error,
  };
};
